import React, { useEffect, useState } from 'react'
import { CgMenu, CgClose } from 'react-icons/cg'

import './TopBar.css'

const TopBar = ({ onClick, sidebarState }) => {
  const [collapsed, setCollapsed] = useState(true)
  useEffect(() => {
    if (sidebarState === 'open') setCollapsed(false)
    else setCollapsed(true)
  }, [sidebarState])

  const toggleNavbar = value => {
    onClick(value)
  }

  return (
    <div className="topbar">
      {collapsed ? (
        <CgMenu className="sidebar-open" onClick={() => toggleNavbar('open')} />
      ) : (
        <CgClose
          className="sidebar-close"
          onClick={() => toggleNavbar('closed')}
        />
      )}
    </div>
  )
}

export default TopBar
